import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-btn rtl-btn" }
const _hoisted_2 = {
  id: "switch",
  class: "switch"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleRTL && _ctx.toggleRTL(...args))),
        id: "slider"
      }),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "slider round" }, null, -1))
    ])
  ]))
}